import { render, staticRenderFns } from "./photo-material-group.vue?vue&type=template&id=c546883a&scoped=true&"
import script from "./photo-material-group.vue?vue&type=script&lang=js&"
export * from "./photo-material-group.vue?vue&type=script&lang=js&"
import style0 from "./photo-material-group.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./photo-material-group.vue?vue&type=style&index=1&id=c546883a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c546883a",
  null
  
)

export default component.exports